import React, { useState, useRef, useEffect } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const InvoiceActionsMenu = ({ invoice, onView, onEdit, onDuplicate, onSend, onApprove, onDelete }) => {
  const documentType = invoice?.documentType || invoice?.DocumentType || 'Invoice';
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef?.current && !menuRef?.current?.contains(event?.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isOpen]);

  const handleAction = (action) => {
    action(invoice);
    setIsOpen(false);
  };

  return (
    <div className="relative" ref={menuRef}>
      <Button
        variant="ghost"
        size="icon"
        onClick={() => setIsOpen(!isOpen)}
        iconName="MoreVertical"
        aria-label="Invoice actions"
      />
      {isOpen && (
        <div className="absolute right-0 top-full mt-1 w-48 bg-popover rounded-lg shadow-xl border border-border z-50 py-1">
          <button
            onClick={() => handleAction(onView)}
            className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
          >
            <Icon name="Eye" size={16} />
            <span>View {documentType === 'Proforma' ? 'Proforma Invoice' : documentType}</span>
          </button>

          <button
            onClick={() => handleAction(onEdit)}
            className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
          >
            <Icon name="Edit" size={16} />
            <span>Edit</span>
          </button>

          <button
            onClick={() => handleAction(onDuplicate)}
            className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
          >
            <Icon name="Copy" size={16} />
            <span>Duplicate</span>
          </button>

          {invoice?.status !== 'Paid' && (
            <>
              <button
                onClick={() => handleAction(onSend)}
                className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
              >
                <Icon name="Send" size={16} />
                <span>Send {documentType === 'Proforma' ? 'Proforma Invoice' : documentType}</span>
              </button>

              {invoice?.status === 'Draft' && documentType === 'Invoice' && (
                <button
                  onClick={() => handleAction(onApprove)}
                  className="w-full px-4 py-2 text-left text-sm text-foreground hover:bg-muted transition-smooth flex items-center gap-2"
                >
                  <Icon name="CheckCircle" size={16} />
                  <span>Approve Invoice</span>
                </button>
              )}
            </>
          )}

          <div className="my-1 border-t border-border"></div>

          <button
            onClick={() => handleAction(onDelete)}
            className="w-full px-4 py-2 text-left text-sm text-error hover:bg-muted transition-smooth flex items-center gap-2"
          >
            <Icon name="Trash2" size={16} />
            <span>Delete</span>
          </button>
        </div>
      )}
    </div>
  );
};

export default InvoiceActionsMenu;